package com.arena_web.data.repository

import com.arena_web.data.api.FeedApi
import com.arena_web.data.dto.FeedPageDto
import com.arena_web.domain.repositories.FeedRepository

class FeedRepositoryImpl(private val feedApi: FeedApi) : FeedRepository {

    override suspend fun getFeed(params: Map<String, String>): Result<FeedPageDto> =
        apiCall { feedApi.getFeed(params) }

    override suspend fun likePost(postId: String, type: String): Result<Map<String, Boolean>> =
        apiCall { feedApi.likePost(postId, type) }
}
